export enum Roles {
  PASSEGGERO = 'PASSENGER',
  OPERATORE = 'OPERATOR',
  ADMIN = 'ADMIN',
}
